import { BruhTimePicker } from "@atoms/bruhTimePicker";
import { Col, Row } from "antd";
import moment from "moment";

type TProps = {
    editing: boolean;
    scheduleTime: { start_time: string; end_time: string };
    onScheduleTimeChange: (value: string, target: 'start_time' | 'end_time') => void;
};

const ScheduleTimeRow = ({ 
    editing, 
    scheduleTime,
    onScheduleTimeChange
}: TProps): JSX.Element => {
    return (
        <Row className="vcentered">
            <Col style={{ minWidth: '120px' }}>
                <label className="required">Время работы</label>
            </Col>
            <Col>
                <label className="hpadded">с</label>
            </Col>
            <Col className="bigger-time">
                { editing ? (
                    <BruhTimePicker
                        closeOnSelect={true}
                        format="HH:mm"
                        onChange={(val, _) => {
                            onScheduleTimeChange(val.format('HH:mm'), 'start_time');
                        }}
                        value={moment(scheduleTime?.start_time, "HH:mm")}
                    />
                ) : (
                    <span className="readonly hpadded">
                        {scheduleTime?.start_time}
                    </span>
                )}
            </Col>
            <Col>
                <label className="hpadded">до</label>
            </Col>
            <Col className="bigger-time">
                { editing ? (
                    <BruhTimePicker
                        closeOnSelect={true}
                        format="HH:mm"
                        onChange={(val, _) => {
                            onScheduleTimeChange(val.format('HH:mm'), 'end_time');
                        }}
                        value={moment(scheduleTime?.end_time, "HH:mm")}
                    />
                ) : (
                    <span className="readonly hpadded">
                        {scheduleTime?.end_time}
                    </span>
                )}
            </Col>
        </Row>
    );
};

export { ScheduleTimeRow };